import {
	fieldValueAtom,
	semanticSearchInitialState,
	semanticSearchStringAtom,
} from '@components/listings-search-bar/atoms';
import type { createStore } from 'jotai/vanilla';

export const getSemanticSearchDataToHydrate = (
	store: ReturnType<typeof createStore>,
) => {
	return {
		fieldValue: store.get(fieldValueAtom),
		semanticSearchString: store.get(semanticSearchStringAtom),
	};
};

export const getSemanticSearchInitialValues = (
	values: ReturnType<typeof getSemanticSearchDataToHydrate>,
) => {
	const { fieldValue } = values || {};

	return [
		[fieldValueAtom, fieldValue || semanticSearchInitialState.searchFieldValue],
		[
			semanticSearchStringAtom,
			fieldValue || semanticSearchInitialState.searchFieldValue,
		],
	];
};
